import {Storage} from "@aws-amplify/storage";
const baseLocation = require('./config');

export const S3_Pool_conf = {
    Auth: {
        identityPoolId: baseLocation.identityPoolId,
        region: baseLocation.region,
        userPoolId: baseLocation.cognitoUserPoolId,
        userPoolWebClientId: baseLocation.cognito_app_client_id,
    },
    Storage: {
        AWSS3: {
            bucket: baseLocation.bucket,
            region: baseLocation.region,
        }
    }
};

export function SetS3Config(bucket, level) {
    Storage.configure({
        bucket: bucket,
        level: level,
        region: baseLocation.region,
        identityPoolId: baseLocation.identityPoolId
    });
}

